import React from "react";
import { Breadcrumb } from "antd";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import getRouters from "../../../routes";
import styles from "./index.module.less";

export default (props) => {
  const {
    location: { pathname },
  } = props;
  const activeNavName = pathname.split("/")[1];
  const subRoutes = getRouters().filter(
    (item) => item.pathName === activeNavName
  )[0]?.routers; // 根据主导航切换菜单; // 根据主导航切换菜单
  const breadPaths = []; // 存放面包屑Items数据源

  // 递归查询树，将获取的路由信息放入到breakPaths
  const getPath = (childRout = []) => {
    for (const item of childRout) {
      const { path, children } = item;
      const pathReg = new RegExp(path.replace(/:\w+/g, "\\w+") + "$"); // 设置正则表达式，用于匹配pathname   '/aaa/:id' =》 "/aaa/\w+$/"
      // console.log('是否匹配',pathReg.test(pathname), path,'=>', pathReg, pathname)
      if (pathReg.test(pathname)) {
        // console.log('路由匹配成功', path);
        breadPaths.unshift(item);
        return true; // 找到就返回，否则继续递归
      } else if (children) {
        const childItem = getPath(children);
        if (childItem) {
          breadPaths.unshift(item);
          return true;
        }
      }
    }
  };
  getPath(subRoutes);

  const title = breadPaths[breadPaths.length - 1]?.title;
  const { t } = useTranslation();
  return (
    <div className={styles.breadCrumbBox}>
      <b className={styles.title}>{t(title)}</b>
      {breadPaths.length > 1 && (
        <Breadcrumb separator=">">
          {breadPaths.map(({ title, component, path, children }, index) => {
            return (
              <Breadcrumb.Item key={`breadCrumb-${index}`}>
                {component && children && index < breadPaths.length - 1 ? (
                  <Link to={path}>{t(title)}</Link>
                ) : (
                  t(title)
                )}
              </Breadcrumb.Item>
            );
          })}
        </Breadcrumb>
      )}
    </div>
  );
};
